import axios from 'axios';
import { refreshTokens } from './authenticationServices';

const getHistory = async (page = 1, page_size = 10) => {
  const url = `${process.env.REACT_APP_API_URL}history?page=${page}&page_size=${page_size}`;
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(url, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getHistoryById = async(id) => {
  const url = `${process.env.REACT_APP_API_URL}history/${id}`;
  const accessToken = localStorage.getItem('access_token');

  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(url, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// export default getHistoryById;
const getMessageById = async (id) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}history/message/${id}`, {
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching message:", error);
    return Promise.reject(error);
  }
};

const deleteHistory = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}history/${id}`;
  const accessToken = localStorage.getItem('access_token');

  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.delete(url, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export {getHistory,getHistoryById,getMessageById,deleteHistory};